module.exports = __webpack_public_path__ + "static/media/gaxon.0571048e.svg";